import React, { Component } from 'react';
import { withRouter } from '#/renderer/router';
import { observer, inject } from 'mobx-react';

import product from '~/helpers/product';
import { addonsList } from '~/store/Addons/Addons';
import { cartPospago, pospagoCartState } from '~/store/States/pospago';

// UI
import UI from './CartSummary.ui';

class CartSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cartInfo: {},
      addonsList: [],
    };
  }

  componentDidMount() {
    this.props.orderStore.getCart().then((response) => {
      if (response.success) {
        const prepagoItems = response.data.data.items.filter(it => it.product.type === '1'
          && product.tipoPlan(it.product.items[0]) !== 'SIM');
        const prepagoQuantity = prepagoItems.reduce((qt, it) => qt + +it.quantity, 0);
        if (prepagoQuantity > 1) {
          this.props.history.push('/cart');
        } else {
          const kit = response.data.data.items.find(item => !!item.part_number_kit);
          if (kit) {
            const { isPagoUnico, pricing, plan, plazo, isIFI } = cartPospago(kit.part_number_kit);
            pospagoCartState.set({
              isPagoUnico,
              pricing,
              plan,
              plazo,
              isIFI,
            });
          }
          this.setState({ cartInfo: response });
        }
      }
    });
    this.addonsList();
  }

  addonsList() {
    addonsList().then((res) => {
      if (res.success) {
        this.setState({
          addonsList: res.data[0].filter(x => x.enabled === true && x.auto_cart === true),
          currentPage: 1,
        });
      }
    });
  }

  render() {
    let cartInfo;
    const orderInfo = this.state.cartInfo;

    if (orderInfo.data && orderInfo.data.data && orderInfo.data.data.items.length) {
      cartInfo = orderInfo.data.data;
    }

    return (
      <UI
        cartInfo={cartInfo}
        addonsList={this.state.addonsList}
      />
    );
  }
}

export default inject('orderStore')(observer(withRouter(CartSummary)));
